var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 43.999c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5S25.757 43.999 23 43.999zM20 4.999A3 3 0 1020 10.998999999999999 3 3 0 1020 4.999zM7 22.999A2 2 0 107 26.999 2 2 0 107 22.999zM11.5 32.999A1.5 1.5 0 1011.5 35.999 1.5 1.5 0 1011.5 32.999zM32.5 13.999c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5S34.43 13.999 32.5 13.999zM9.5 16.999c1.381 0 2.5-1.119 2.5-2.5s-1.119-2.5-2.5-2.5l0 0c-1.381 0-2.5 1.119-2.5 2.5S8.119 16.999 9.5 16.999zM35.5 37.999c-2.481 0-4.5-2.019-4.5-4.5s2.019-4.5 4.5-4.5 4.5 2.019 4.5 4.5S37.981 37.999 35.5 37.999zM39 25c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4S41.206 25 39 25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverall);
export default __webpack_public_path__ + "static/media/overall.92594e1fb603cc1ef4f1efb746442b2c.svg";
export { ForwardRef as ReactComponent };